import { useDevicesContext } from "@hireroo/app-helper/hooks";
import { RemoteUser, useAgoraPublish, useAgoraRemoteUsers } from "@hireroo/app-helper/livecoding/agora";
import { Auth } from "@hireroo/app-store/essential/employee";
import { Widget } from "@hireroo/presentation";
import * as React from "react";

import LiveCodingAudioSpeakerContainer from "../../../../../../widget/v2/shared/LiveCodingAudioSpeaker/Container";
import LiveCodingVideoViewContainer from "../../../../../../widget/v2/shared/LiveCodingVideoView/Container";

export type GenerateLiveCodingVideoChatGalleryLayoutPropsArgs = {};

export const useGenerateProps = (_: GenerateLiveCodingVideoChatGalleryLayoutPropsArgs): Widget.LiveCodingGalleryLayoutProps => {
  const uid = Auth.useCurrentUid();

  const { isAudioEnabled, isVideoEnabled, audioTrack, videoTrack } = useDevicesContext();
  useAgoraPublish({ audioTrack, videoTrack, isAudioEnabled, isVideoEnabled });

  const remoteUsers = useAgoraRemoteUsers();

  const localUser = React.useMemo((): RemoteUser => {
    return {
      uid: uid || "",
      hasAudio: isAudioEnabled,
      hasVideo: isVideoEnabled,
    };
  }, [uid, isAudioEnabled, isVideoEnabled]);

  return {
    AudioComponents: remoteUsers.map(remoteUser => {
      return <LiveCodingAudioSpeakerContainer key={remoteUser.uid.toString()} user={remoteUser} />;
    }),
    VideoComponents: [
      <LiveCodingVideoViewContainer key="local" user={localUser} isLocal={true} />,
      ...remoteUsers.map(remoteUser => {
        return <LiveCodingVideoViewContainer key={remoteUser.uid.toString()} user={remoteUser} />;
      }),
    ],
  };
};
